import gsap from "gsap";

// ! rename the function to align with the widget name
export const partnersMarquee = () => {
    const el = document.querySelector('.curious-partners-marquee');
    if (!el) return;

    // ------------------------------------------------------------

   const marquee = el.querySelector('.marquee');
    if (!marquee) return;

    // Correct direction: left = 1, right = -1
    const direction = marquee.dataset.direction === 'left' ? 1 : -1;

    // Duplicate content for seamless scroll
    const items = [...marquee.children];
    items.forEach(item => marquee.appendChild(item.cloneNode(true)));

    const totalWidth = marquee.scrollWidth / 2;

    if (direction === 1) {
      // Scroll left: move from 0 → -totalWidth
      gsap.to(marquee, {
        x: -totalWidth,
        duration: 60, // adjust for speed
        ease: "linear",
        repeat: -1
      });
    } else {
      // Scroll right: move from -totalWidth → 0
      gsap.set(marquee, { x: -totalWidth });
      gsap.to(marquee, {
        x: 0,
        duration: 60, // adjust for speed
        ease: "linear",
        repeat: -1
      });
    }

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

